/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa Currency Converter
 *
 */
Intesa.FormsVub = function() {
	
    /**
	 *  Variables
	 *
	 */
	
	var formsVub = this;
	var genericSettings = {};


	/**
	 * Init component
	 *
	 */
	
this.init = function() {		
	var bankName =  $('html').attr('data-bank');
	if(bankName == "VUB"){
		formsVub.getSettingsAndLabelsJsonData();
		var checkBusiness = $("#deferralLoanBusiness").length;
		var check = $("#deferallLoan").length > 0 ;
		var checkWithdrawal;
		var cashWithdrawal;
		if($("#formType").length > 0){
    		 checkWithdrawal =  $("#formType").val();
    		 if(checkWithdrawal == "cashWithdrawal"){
    			 cashWithdrawal= true;
    		 }else {
    			 cashWithdrawal= false;
    		 }
		}
		$("#deferralLoanBusiness").length > 0 ? checkBusiness = $("#deferralLoanBusiness").val() : checkBusiness = false;
		$("#deferallLoan").length > 0 ? check = $("#deferallLoan").val() : check = false;
		$("#gdprForm").length > 0 ? gdprForm = true : gdprForm = false;
	    var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
	    var mobileCheck = width < 768;
	    //console.log("check mobile",mobileCheck);
	    if(bankName == "VUB" && check == "true" ){
	    	//console.log("inside");
	    	if( mobileCheck.toString() == "false"){
	    		formsVub.blankSpacesForm();
	    	}
	    	formsVub.hideMailPickup(true,mobileCheck);
	    	formsVub.showHideMailPickup();
	    }else if (bankName == "VUB" && checkBusiness == "true" ){
	    	//console.log("inside Business");
	    	formsVub.hideMailPickup(false,mobileCheck);
	    	if( mobileCheck.toString() == "false"){
	    		formsVub.blankSpacesForm();
	    	}
	    	formsVub.showHideMailPickupBusiness();
	    	formsVub.deferralLoanRepayment();
	    	formsVub.moreInfoCheckbox();
	    	formsVub.submitCheck();
	    }else if (bankName == "VUB" && cashWithdrawal){
	    	formsVub.arrowDisplay();
	    	formsVub.addMoreOrder();
	    }else if (bankName == "VUB" && gdprForm){
	    	formsVub.hideMailPickup(false,mobileCheck);
	    	formsVub.showHideMailPickup();
	    	formsVub.otpInput();
			formsVub.gdprCall();
			formsVub.initGDPRComponents();
	    }
	    formsVub.setDataLayerFields();
	    formsVub.dataPushDataLayerVub();
	    formsVub.dataLayerOpenChat();
	    formsVub.componentsToParse();
	}
} //VENGONO CHIAMATI I METODI A SECONDA DEL FORM CORRENTE (GESTISCE DEFERRAL OF LOAN , CASH WITHDRAWAL E DEFERRAL OF LOAN BUSINESS)


this.otpInput = function(){
	$('.rstep2-gdpr').find('input').each(function() {
		$(this).attr('maxlength', 1);
		$(this).on("keyup", function(e){

			var parent = $($(this).parent());
		
			if(e.keyCode === 8 || e.keyCode === 37) {
			var prev = parent.find('input#' + $(this).data('previous'));
			
			if(prev.length) {
				$(prev).select();
				e.stopPropagation();
			}
			}else if((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 39) {
			var next = parent.find('input#' + $(this).data('next'));
			
			if(next.length && $(this).val().length > 0){
				$(next).select();
				e.stopPropagation();
			} else {
				console.log("last-step");
			}
		}
		});

	});
}

this.getSettingsAndLabelsJsonData = function() {

	var settings = $( "#genericSettings" );
	var labels = $( "#calculatorLabels" );

	try {

		// get generic settings
		if( settings.length ) {
			genericSettings = JSON.parse( settings.val() );
		}

		// get calculator labels
		if( labels.length ) {
			calculatorLabels =  JSON.parse( labels.val() );
		}

	} catch(e) {

		console.error( 'Settings or Labels JSON file invalid' );
		invalidJsonFiles = true;

	}

};//GENERIC SETTINGS

this.dataPushDataLayerVub = function (){
	var submit = $("#data-success-submit").length > 0;
	if(submit){
		var formType = $("#formType").length > 0;
		if(formType){
			formType =  $("#formType").val();
			switch (formType.toUpperCase()){
				case "CONTACT":
					var topic = localStorage.getItem("topic");
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
					'event': 'service',                	// fixed value
					'eventCategory': 'contactus',          // fixed value
					'eventAction': 'submit',          	// fixed value
					'eventLabel': topic,               // dynamic value
					'eventName': 'contact us'            	// fixed value
					});
					console.log("Data Layer Push Contact Us");
					localStorage.removeItem('topic');
					break;
				case "COMPLAINT":
					var salesChannel = localStorage.getItem("salesChannel");
					var service = localStorage.getItem("service");
					var product = localStorage.getItem("product");
					window.dataLayer.push({
						'event': 'service',					// fixed value
						'eventCategory': 'complaints',			// fixed value
						'eventAction': salesChannel,   		// dynamic value
						'eventLabel': service,		          	// dynamic value
						'eventName': 'complaints',     // fixed value
						'product': product			// dynamic value
					});
					console.log("Data Layer Push Complaint");
					localStorage.removeItem('salesChannel');
					localStorage.removeItem('service');
					localStorage.removeItem('product');
					break;
				default :
					console.log("form non gestito da data layer");
					break;
				}
			}
		}

}


this.gdprCall = function() {
	
	$("[name='firstButtonGDPR'").on("click" ,function(){
	    //console.log("send");
	    
	    var checkParsley = $(".for__form").parsley({excluded: "input[type=text]:hidden, input[type=hidden]"}).validate();
	    
	    //MOCK
	    // checkParsley=true;
	    
	    formsVub.refreshOtpDigits();
	    
	    if(checkParsley){
	    	var subtitle;
	    	var formUrl = "/otpServlet/?operation=sendOtp";
        	var thisForm = $(this).parents( "form" );
        	var phoneFromInput = $(thisForm).find("[name='phoneNumber']").val().toString();
			var actualPhone = "0" + phoneFromInput;
			var phoneLocale =  localStorage.getItem("phoneNumber") != null ?  localStorage.getItem("phoneNumber") : null ;

			var formSerialized = thisForm.serialize();
			formSerialized = formSerialized.replace(/(phoneNumber=)(\d+)/, "$1" + actualPhone);
		    
			if( $("#messageId").val().length > 0 && actualPhone == phoneLocale ){
				$("#otpSubmitModal").modal("show");
			}else{
		    $.ajax( {
            type: "POST",
            data: formSerialized,
            url: formUrl,
            success: function( data ) {
            //console.log("DATA -> ",data);
            $('[name="secondButtonGDPR"]').prop('disabled', true);
            formsVub.removeErrorTentativeOtpDigits();
			$("#otpSubmitModal").find("#otp__invalid__error_retry").addClass("hide");
			formsVub.substituteOtpTentativeNumber();
            switch(data.status) {
                case "OK":
                	//console.log("OK");
                	//console.log(data.messageId);
            	    $('.rstep2-gdpr').removeClass('rhide-gdpr');
            	    $("#messageId").val(data.messageId);
					localStorage.setItem("phoneNumber", actualPhone );
					$("#otpSubmitModal").modal("show");
					// subtitle = $("#otpSubmitModal").attr("data-subtitle-message");
					// $("#otpSubmitModal").find("#modal_subtitle_confirm_gdpr").text(subtitle);
					$("#otpSubmitModal").find("#modal_subtitle_confirm_gdpr").removeClass("hide");
					$("#otpSubmitModal").find("#modal_subtitle_error_gdpr").addClass("hide");
					$("#otpSubmitModal").find("#modal_subtitle_tooManyerror_gdpr").addClass("hide");
					$("#otpSubmitModal").find(".modal-body").show();
					$("#otpSubmitModal").find(".modal-footer-custom").show();
					$("#otpSubmitModal").find(".modal-footer-custom-confirm").addClass("hide");
                	break;
                case "ERR":
                	//console.log("ERR");
                	//console.log(data.messageId);
            	    $('.rstep2-gdpr').removeClass('rhide-gdpr');
            	    $("#messageId").val(data.messageId);
					localStorage.setItem("phoneNumber", actualPhone );
					$("#otpSubmitModal").modal("show");
					//subtitle = $("#otpSubmitModal").attr("data-subtitle-error-message");
					// $("#otpSubmitModal").find("#modal_subtitle_error_gdpr").text(subtitle);
					$("#otpSubmitModal").find("#modal_subtitle_error_gdpr").removeClass("hide");
					$("#otpSubmitModal").find("#modal_subtitle_confirm_gdpr").addClass("hide");
					$("#otpSubmitModal").find("#modal_subtitle_tooManyerror_gdpr").addClass("hide");
					$("#otpSubmitModal").find(".modal-body").hide();
					$("#otpSubmitModal").find(".modal-footer-custom").show();
					$("#otpSubmitModal").find(".modal-footer-custom-confirm").addClass("hide");
                	break;
                default:
                	console.log("Default");
              }
            },
            error: function( err ) {
	          	console.log("Error");
            }
          });	
		    
	    }
	    }
	    else{
	    	
	    	var validate_checkbox = $(".for__form").parsley().validate("checkbox-block");
	    	if(!validate_checkbox){
	    		
	    		document.getElementById('gdpr__checkboxes__form').scrollIntoView()
	    		
	    	}
	    	console.log("Parsley Error");
	    	
	    }
	    
	});	
	
	
	$("[name='secondButtonGDPR'").on("click" ,function(){
	    //console.log("check");
	    
	    var formUrl = "/otpServlet/?operation=checkOtp";
        var thisForm = $(this).parents( "form" );
	    var checkParsley = $(".for__form").parsley({excluded: "input[type=text]:hidden, input[type=hidden]"}).validate();
		var modal = $(this).parents( "#otpSubmitModal" );
		var otp = formsVub.generateOtp();
        //console.log("form data->",thisForm.serialize());
	    
        //MOCK
	    // checkParsley=true;
	    
	    if(checkParsley && otp){
        
		$("#test_GDPR_phone").val(otp);

		//console.log("otp ->",otp);
        
	    $.ajax( {
            type: "POST",
            data: thisForm.serialize(),
            url: formUrl,
            success: function( data ) {
			var err;
            //console.log("DATA -> ",data);
			
            switch(data) {
                case "ERR":
                	//console.log("Errore 3");
					err = modal.attr("data-error-message");
					//console.log("ERROR MESSAGE ->",err);
					$("#otpSubmitModal").find("#modal_subtitle_error_gdpr").addClass("hide");
					$("#otpSubmitModal").find("#modal_subtitle_confirm_gdpr").addClass("hide");
					$("#otpSubmitModal").find("#modal_subtitle_tooManyerror_gdpr").removeClass("hide");
					modal.find(".modal-body").hide();
					modal.find(".modal-footer-custom").hide();
					modal.find(".modal-footer-custom-confirm").removeClass("hide");
					formsVub.refreshOtpDigits();
                	break;
                case "RET":
                	formsVub.updateOtpTentativeNumber()
                	//console.log("Errore < 3");
					//console.log("ERROR RETRY MESSAGE");
					formsVub.refreshOtpDigits();
					formsVub.addErrorTentativeOtpDigits();
					$("#otpSubmitModal").find("#otp__invalid__error_retry").removeClass("hide");
                	break;
                case "OK":
                	//console.log("OK");
					formsVub.handleResponse(true, modal);
					formsVub.refreshOtpDigits();
					formsVub.removeErrorTentativeOtpDigits();
					$("#otpSubmitModal").find("#otp__invalid__error_retry").addClass("hide");
					localStorage.setItem("phoneNumber", "" );
                	break;
				case "WSKO":
					//console.log("WSKO");
					formsVub.handleResponse(false, modal);
					formsVub.refreshOtpDigits();
					formsVub.removeErrorTentativeOtpDigits();
					$("#otpSubmitModal").find("#otp__invalid__error_retry").addClass("hide");
                	break;
                default:
                	console.log("Default");
              }
            },
            error: function( err ) {
	          	console.log("Error");
            }
          });	    
	    
	    }else{
	    	
	    	console.log("Parsley Error");
	    	
	    }
	    
	});	
	
}

this.generateOtp = function (){
	var finalString = "";
	$(".rstep2-gdpr input.otpInput").each(function(){
		finalString = finalString.concat($(this).val().toString());
	});
	if( finalString.length == 6){
		//console.log("finalString ->",finalString);
		return finalString;
	}else{
		//console.log("Error finalString ->",finalString);
		return null;
	}
}//GENERA LA STRING FINALE DELL'OTP DAI 6 CAMPI DI INPUT | SE LA STRING NON è DI 6 CARATTERI ALLORA VIENE RITORNATO NULL


// REFRESH DEGLI INPUT OTP
this.refreshOtpDigits = function (){
	$(".rstep2-gdpr input.otpInput").each(function(){
		$(this).removeClass("red__border__validation__otpinput");
		$(this).val("");
	});
	$('[name="secondButtonGDPR"]').prop('disabled', true);
}

//ADD ERROR INPUT OTP
this.addErrorTentativeOtpDigits = function (){
	$(".rstep2-gdpr input.otpInput").each(function(){
		$(this).addClass("red__border__validation__otpinput");
	});
}

//REMOVE ERROR DEGLI INPUT OTP
this.removeErrorTentativeOtpDigits = function (){
	$(".rstep2-gdpr input.otpInput").each(function(){
		$(this).removeClass("red__border__validation__otpinput");
	});
}


//INIT NUMERO TENTATIVI OTP
this.substituteOtpTentativeNumber = function() {
	
	formsVub.otpTentativeNumber = 3;

	 var stringhtml = $("#otp__invalid__error_retry").get(0).outerHTML.replace("{otp_tentative_number}", "<span id='otp__tentative__number__dynamic'>" + formsVub.otpTentativeNumber.toString() + "</span>");
	 $("#otp__invalid__error_retry").replaceWith(stringhtml);
	 
};


//UPDATE NUMERO TENTATIVI OTP
this.updateOtpTentativeNumber = function() {
	
	formsVub.otpTentativeNumber = formsVub.otpTentativeNumber - 1;
	
	$("#otp__tentative__number__dynamic").text(formsVub.otpTentativeNumber.toString());
		 
};


this.handleResponse = function (isDone , modal ){

	var errorTitle = $("#notifcationGdprType").attr("data-error-title-message");

	var errorMessage = $("#notifcationGdprType").attr("data-error-description-message");

	var successMessage = $("#notifcationGdprType").attr("data-success-description-message");

	var successTitle = $("#notifcationGdprType").attr("data-success-title-message");

	var typeNotification = $("#notifcationGdprType").length > 0 ? $("#notifcationGdprType") : null ;

	if( typeNotification != null ){

		formsVub.resetResultMessage();

		if(isDone){

			typeNotification.addClass("com3-4");
			typeNotification.find(".com3__icon").removeClass("icon-ic_error");
			typeNotification.find(".com3__icon").addClass("icon-ic_check");
			typeNotification.find(".com3__title").text(successTitle);
			typeNotification.find(".com3__description").text(successMessage);

			if(!$("#notificationGdpr").is(":visible"));
				$("#notificationGdpr").removeClass("hide");

			if(!$("#notifcationGdprType").is(":visible"));
				$("#notifcationGdprType").css("display", "block");

			
			//console.log("Send Mail Has Been Performed");


		}else{

			typeNotification.addClass("com3-3");
			typeNotification.find(".com3__icon").removeClass("icon-ic_check");
			typeNotification.find(".com3__icon").addClass("icon-ic_error");
			typeNotification.find(".com3__title").text(errorTitle);
			typeNotification.find(".com3__description").text(errorMessage);

			if(!$("#notificationGdpr").is(":visible"));
				$("#notificationGdpr").removeClass("hide");

			if(!$("#notifcationGdprType").is(":visible"));
				$("#notifcationGdprType").css("display", "block");
			
			//console.log("WS-KO");

		}

		modal.modal("hide");
		$("#notificationGdpr").removeClass("hide");

	}else{

		console.log("element not found");

	}

}//GESTISCE IL MESSAGGIO DI ERRORE O DI SUCCESSO DEL SERVIZIO

this.resetResultMessage = function (){

	var typeNotification = $("#notifcationGdprType").length > 0 ? $("#notifcationGdprType") : null ;

	if(typeNotification.hasClass("com3-2"));
		typeNotification.removeClass("com3-2");
	
	if(typeNotification.hasClass("com3-3"));
		typeNotification.removeClass("com3-3");

	if(typeNotification.hasClass("com3-4"));
		typeNotification.removeClass("com3-4");

}//RESETTA IL MESSAGGIO DI SUCCESSO O ERRORE NEL FORM GDPR

this.initGDPRComponents = function (){
	
	// HIDE CAMPI NASCOSTI DAL CHECKBOX
	
	var $containerMailBoxError = $("#containerMailboxError"); 
	
	$containerMailBoxError.find('input').each(function() {
		$(this).attr("required", false);
	});
	
	formsVub.substituteOtpTentativeNumber();

	// PERMETTE DI MOSTRARE TUTTI I GIUSTI CAMPI PER OGNI SELEZIONE DI POSSIBILI REQUEST DI GDPR FORM E DI RIEMPIRE GLI INPUT
	
	$("#item_select_component_gdpr").change(function(){
		formsVub.cleanInputTextArea();
		$(".for__form").parsley().validate("checkbox-block");
		$(".r-select-component-gdpr").addClass("rhide-gdpr");
		var selectedValue = $("#item_select_component_gdpr").val();
		var classToSetVisible = ".r-select-component-gdpr-" + selectedValue;
		$(classToSetVisible).removeClass("rhide-gdpr");
		
		
		$(".selecteGDPR").each(function () {
			
			$(this).prop('required',false);
			
		})
		
		
		$(".selecteGDPR:visible").each(function () {
			
			formsVub.fillInputTextArea(this);
			
			if($(this).hasClass("required-gdpr")){
				$(this).prop('required',true);
			}
			
		})
		
		$(".otpInput").keyup(function(){
			formsVub.removeErrorTentativeOtpDigits();
			var checkOtpInserted = true;
			$('.otpInput').each(function(index, el){
			  var checkSingleOtp = $(el).parsley({excluded: "input[type=text]:hidden, input[type=hidden]"}).validate().toString();
			  if(checkSingleOtp !== "true"){
				  checkOtpInserted = false;
			  }
			});
			if(checkOtpInserted){
				$('[name="secondButtonGDPR"]').removeAttr("disabled");
			}
			else{
				$('[name="secondButtonGDPR"]').prop('disabled', true);
			}
		});
	});	

	
	
	$(".selecteGDPR").on("keyup", function () {
		
		$(".selecteGDPR:visible").each(function () {
			formsVub.fillInputTextArea(this);	
		});
		
	});
	
	
	// MODIFICA IL COMPORTAMENTO DEL PARSLEY VALIDATOR SUI CONTENITORI DEL CHECKBOX
	
	var firstCheckbox = document.querySelector(".checkbox__gdpr__visibility");
	$(firstCheckbox).parsley().on('field:error', function() {
	  
		$(".validation_error_checkbox_border").each(function () {
			$(this).removeClass("red__border__validation__checkbox");
			if(!$(this).is(':checked')){
				$(this).addClass("red__border__validation__checkbox");
			}
		})
		
		setTimeout(function() { document.activeElement.blur(); }, 10);
		
	});
	
	$(firstCheckbox).parsley().on('field:success', function() {
	  
		$(".validation_error_checkbox_border").each(function () {
			$(this).removeClass("red__border__validation__checkbox");
		})
		
	});


	$("#item_select_component_gdpr").change(function(){

	var valueToSave;
	
	var currentOption = parseInt($(this).val().toString());

	var optionElement = $(this).find("option[value="+currentOption+"]").length > 0 ?  $(this).find("option[value="+currentOption+"]") : null ;

	if(optionElement){

		valueToSave = optionElement.text();

		// console.log("content of select ->",valueToSave);

		$("#item_select_component_gdpr_value").val(valueToSave);
	}else{

		console.log("ELEMENT NOT FOUND");

	}

	});
	
	
	$('[name="birthdate"]').change(function(){
		$(this).parsley().validate();
		if($('[name="birthdate"]').val() !== '' && $('[name="birthdate"]').val() !== null && $('[name="birthdate"]').val() !== undefined){
	    	$(".birthdate__gdpr>div").addClass("fc-edited");
	    }
	    else{
	    	$(".birthdate__gdpr>div").removeClass("fc-edited");
	    }
	});

	
	$(".gdpr__mobile [data-id='item_dynamicDropdown']").change(function(){
		if($("[data-id='item_dynamicDropdown']").prop('selectedIndex') == 2){
	        $(".identification__gdpr").addClass("hide__gdpr__component");
	        $(".birthdate__gdpr").removeClass("hide__gdpr__component");
	    } else {
	        $(".birthdate__gdpr").addClass("hide__gdpr__component");
	        $(".identification__gdpr").removeClass("hide__gdpr__component");
	    }
	});
	
}
	

this.cleanInputTextArea = function (){
	
	$(".textArea-gdpr-input").each(function () {
		$(this).val("");
	})
	
}



this.fillInputTextArea = function (element){
	
	var name = element.name;
	var value = element.value;
	var input_name = "input_" + name;
	$("#" + input_name).val(value);
	
}



this.setDataLayerFields = function () {
	$(".j-leaveMessage__submit").on("click",function(){
		var formType = $("#formType").length > 0;
		if (formType){
			formType =  $("#formType").val();
			switch (formType.toUpperCase()){
			case "CONTACT":
				localStorage.setItem("topic", $("#item_selectSubject").val());
				break;
			case "COMPLAINT":
				localStorage.setItem("salesChannel" ,"");
				localStorage.setItem("service", "");
				localStorage.setItem("product", $("#item_selectSubject").val());
				break;
			default :
				console.log("form non gestito da data layer");
				break;
			}
		}
	});
}


this.dataLayerOpenChat = function (){
	$("#startChatBtn").on("click", function (){
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
		'event': 'service',			// fixed value
		'eventCategory': 'chat',		// fixed value
		'eventAction': 'submit',		// fixed value
		'eventLabel': window.dataLayer[0].pageName ,	// fixed value
		'eventName': 'chat'			// fixed value
		});
	});
}

this.arrowDisplay = function (){
	$("a.arrowAdaptive").after().on("click" ,function() {
		var  visible = $(".containerOrder ").hasClass("hide");
    		if(visible){
    			$(".containerOrder ").removeClass("hide");
    			$(".arrowAdaptive").addClass("open");
			}else{
				$(".containerOrder ").addClass("hide");
				$(".arrowAdaptive").removeClass("open");
			}
	});
}//ARROW CASH WITHDRAWAL

this.submitCheck = function (){
	$(".j-leaveMessage__submit").on("click",function (){
		var check = $(".for__checkbox__mailbox__business").is(":visible");
		var parsleyCheck = $(".for__form").parsley({excluded: "input[type=text]:hidden, input[type=hidden]"}).validate();
		//console.log(parsleyCheck);
		//console.log(check);
		if(check && parsleyCheck == false ){
			$(".for__checkbox__mailbox__business").addClass("hide");
			$("#containerMailboxError").show();
			$(".blank").removeClass("hide");
			$("#containerMailboxError").addClass("containerMailboxError");
			$("#errorContainer").removeClass("hide");
	        //console.log("submit check");
		}
	});
} // DEFERRAL OF LOAN BUSINESS , SE I CAMPI NASCOSTI NON SONO STATI COMPILATI LI RIVELA MOSTRANDO UN BORDO ROSSO

this.moreInfoCheckbox = function (){
	$(".for__checkbox.more").each(function (index){
		  var inner = $(this).find(".for__checkbox__inner");
		  var text = inner.find("p");
		  //console.log("Index"+index);
		  //console.log(text.text());
		  //console.log(text.text().length);
		  var textLength = text.text().length;
		  if(textLength > 210){
		      //console.log("Dentro condizione");
		      var string = text.text();
		      var cmd = string.substring(0,210);
		      //var firstRow = adjustFirstRow(cmd);
		      //console.log(cmd);
		      var startString = cmd;
		      text.text(startString);
		      var moreInfoButton = $(this).find(".moreInfo");
		      var arrow = moreInfoButton.find(".arrowAdaptive");
		      moreInfoButton.removeClass("hide");
		      formsVub.showOriginalMessage(string ,text , arrow);
		    }
		  
		});
} // TRONCA LE STRINGHE DEL CHECKBOX OGNI N CARATTERI E FA VEDERE UN PULSANTE "MORE INFO". AL CLICK DEL PULSANTE VIENE RIVELATA LA STRINGA ORIGINARIA

this.showOriginalMessage = function(string , target, arrow){
	arrow.on("click", function (){
		target.text(string);
		arrow.parent().hide();
	});
} // IMPLEMENTATO CON "MOREINFOCHECKBOX" PERMETTE DI ANDARE A NASCONDERE IL PULSANTE MOREINFO DOPO IL CLICK E DI FAR VISUALIZZARE LA STRINGA INIZIALE

this.showHideMailPickup = function(){
	$("#mailPickup").change(function(){
		var $containerMailBoxError = $("#containerMailboxError"); 
	    if(!$containerMailBoxError.is(":visible")){
			$containerMailBoxError.show();
			$(".blank").removeClass("hide");

			$containerMailBoxError.find('input').each(function() {
				$(this).attr("required", true);
			});
	    }else{
	    	$containerMailBoxError.hide();
			$(".blank").addClass("hide");
			
			$containerMailBoxError.find('input').each(function() {
				$(this).attr("required", false);
			});
	    }
	});	
} //DEFERRAL OF LOAN ,PERMETTE DI NASCONDERE I CAMPI NON OBBLIGATORI . VEGONO VISUALIZZATI AL CLICK DEL CHECKBOX. (AGGIUNGERE MANUALEMNTE ID DI UN NUOVO COMPONENTE)

this.showHideMailPickupBusiness = function (){
	$("#mailPickupBusiness").on("click" ,function(){
	    //console.log("evento");
	    if(!$("#item_municipalityMailPickupAddress").is(":visible")){
	    	$(".for__checkbox__mailbox__business").addClass("hide");
			$("#containerMailboxError").show();
			$(".blank").removeClass("hide");
	        //console.log("mostro");
	    }
	});	
} //DEFERRAL OF LOAN BUSINESS , PERMETTE DI MOSTRARE TUTTI I CAMPI CONTENUTO IN UN CONTAINER. 

this.blankSpacesForm = function (){
	//console.log("blanckSpaceForm");
	var countCons = 0;
	$(".for__leaveMessage__formItem").each(function(index, el){
		if($(this).parent().parent().find("form").attr("id") != 'cmb__form' ){
		    if($(this).hasClass( "for__leaveMessage__formItem--fullWidth" )){
		        //console.log("test:",$(this));
		        if((countCons%2) == 1){
		        	if($(this).prev().is(":visible") && $(this).prev().attr("id") == "containerMailboxError"){
			            $('<div class="for__leaveMessage__formItem hide blank"><div class="form__title__inner"><p></p></div><div class="label-inside"><div class="form-control " style="border:none!important"></div></div></div>').appendTo($(this).prev());
		        	}else if($(this).prev().is(":visible")){
			            $('<div class="for__leaveMessage__formItem"><div class="form__title__inner"><p></p></div><div class="label-inside"><div class="form-control " style="border:none!important"></div></div></div>').insertAfter($(this).prev());
		        	}else if($("#containerMailboxError").length > 0){
			            $('<div class="for__leaveMessage__formItem hide blank"><div class="form__title__inner"><p></p></div><div class="label-inside"><div class="form-control " style="border:none!important"></div></div></div>').appendTo($(this).prev());
		        	}else {
 			            $('<div class="for__leaveMessage__formItem hide blank"><div class="form__title__inner"><p></p></div><div class="label-inside"><div class="form-control " style="border:none!important"></div></div></div>').insertAfter($(this).prev());
		        	}
		            countCons = 0;
		        }else{
		            countCons = 0;
		        }
		    }else{
		        countCons ++;
		        //console.log("count=",countCons);
		    }
		}else{
				countCons ++;
				//console.log($(this).parent().parent().find("form").attr("id"));
				//console.log("floating form skipped");
				//console.log($(this));
		}
	})
}// AGGIUNGE UN DIV VUOTO ED INVISIBILE IN MODO DA POTER GESTIRE LE MEZZE COLONNE DISPARI, GESTISCE ANCHE I CASI IN CUI CI SIA IL CONTAINER INVISIBILE OPPURE DEI CAMPI INVISIBILI

this.hideMailPickup = function(isRetail,mobileCheck){
	var isEditMode = $("#editMode").val();
	if(isEditMode != "true"){
		$("#containerMailboxError").hide();
		if(isRetail){
			if(mobileCheck){
				$('#checkboxMailPickupDeferral').insertAfter('#containerMailboxError');
			}
		}
		
	}
} // SE NON SIAMO IN EDIT MODE NASCONDE I CAMPI DEL DEFERRAL OF LOAN BUSINESS OPPURE DEFERRAL OF LOAN RETAIL SE E' RETAIL ED E' MOBILE INVERTE L'ORDINE DEL CHECKBOX

this.deferralLoanRepayment = function(){
	$("label.for__radio.for__radio__label.inpage-radio").find("input[type=radio]").change(function (){
    $("label.for__radio.for__radio__label.inpage-radio").each(function (index){
    var checked = $(this).find("input").is(':checked');
    if(checked.toString() == "true"){
        //console.log(index);
        if(index == "2"){
            $("#repaymentDate").parent().parent().find(".for__datePicker").addClass("hide");
            $("#repaymentDate").addClass("disabled");
            $("#repaymentDate").val("");
            if ($("#repaymentDate").prop("required")){
            	$("#repaymentDate").prop("required",false)
            }else{
            	 console.log("not required");
            }
            
        }else{
            $("#repaymentDate").parent().parent().find(".for__datePicker").removeClass("hide");
            $("#repaymentDate").removeClass("disabled");
            if($("#repaymentDate").attr("data-required") == "true"){
            	$("#repaymentDate").prop("required",true)
            }else{
            	console.log("not required");
            } 
        }
    }
    });
});
}//PERMETTE DI DISABILITARE L'ACQUISIZIONE DELLA DATA SE E' STATO SELEZIONATO IL TERZO RADIO 

this.addMoreOrder = function(){
	$("#addMoreButton").on("click", function (){
		if($(".containerOrderClone").length <= 4){
			if($(".containerOrderClone").length == 4){
				//console.log("ultimo step");
			    $(".addMore").hide();
			}
		    //console.log("dentro");
		    var clonedContainer = $(".containerOrderClone").eq(0).clone(true,true);
		    var pieces = clonedContainer.find("input[name='pieces']");
		    var amount = clonedContainer.find("input[name='amountOrder']");
		    var labelPiece = clonedContainer.find("label[for='item_pieces']");
		    var labelAmount = clonedContainer.find("label[for='item_amountOrder']");
		    var containerErrorPiece = clonedContainer.find(".phoneNumberMessages__withdrawalPieces");
		    var containerErrorAmount = clonedContainer.find(".phoneNumberMessages__withdrawalAmount");
		    pieces.removeData("Parsley");
		    pieces.removeClass("parsley-error");
		    amount.removeData("Parsley");
		    amount.removeClass("parsley-error");
		    pieces.val("");
		    amount.val("");
		    containerErrorAmount.find("ul.parsley-errors-list.filled").remove();
		    containerErrorAmount.removeClass("phoneNumberMessages__withdrawalAmount");
		    containerErrorAmount.addClass("phoneNumberMessages__withdrawalAmount"+$(".containerOrderClone").length);
		    containerErrorPiece.find("ul.parsley-errors-list.filled").remove();
		    containerErrorPiece.removeClass("phoneNumberMessages__withdrawalPieces");
		    containerErrorPiece.addClass("phoneNumberMessages__withdrawalPieces"+$(".containerOrderClone").length);
		    pieces.attr("name", 'pieces'+$(".containerOrderClone").length);
		    pieces.attr("id", 'item_pieces'+$(".containerOrderClone").length);
		    pieces.attr("data-parsley-errors-container", '.phoneNumberMessages__withdrawalPieces'+$(".containerOrderClone").length);
		    amount.attr("name", 'amountOrder'+$(".containerOrderClone").length);
		    amount.attr("id", 'item_amountOrder'+$(".containerOrderClone").length);
		    amount.attr("data-parsley-errors-container", '.phoneNumberMessages__withdrawalAmount'+$(".containerOrderClone").length);
		    labelAmount.attr("for", "item_amountOrder"+$(".containerOrderClone").length);
		    labelPiece.attr("for", "item_pieces"+$(".containerOrderClone").length);
		    var calcContainer = ($(".containerOrderClone").length)-1 ;
		    //console.log("calcContainer",calcContainer);
		    amount.parsley();
		    pieces.parsley();
		    clonedContainer.find("[name='currencyOrder']").attr("name","currencyOrder"+$(".containerOrderClone").length);
		    clonedContainer.insertAfter($(".containerOrderClone").eq(calcContainer));
		    formsVub.componentsToParse();
		    //$(".phoneNumberMessages__withdrawalAmount"+$(".containerOrderClone").length+" ul.parsley-errors-list.filled").remove();
		    //$(".phoneNumberMessages__withdrawalPieces"+$(".containerOrderClone").length+" ul.parsley-errors-list.filled").remove();
		}else{
		    //console.log("TERMINATED");
		    $(".addMore").hide();
		}
	});
}//AGGIUNGE UN NUOVO ORDINE DEL WITHDRAWAL AL CLICK DELL'ADD MORE 

this.componentsToParse = function () {
	$( ".validatorDecimal").each(function() {
		//console.log("elment parse :",$(this));
		$(this).parsley(formsVub.formatParsleyDecimalValue());
	});
}//COMPONENTI DA FORMATTARE


this.formatParsleyDecimalValue = function() {
	return {
		value: function(parsley) { 
			return $(parsley.element).val().replaceAll(genericSettings.separator, '').replace(genericSettings.decimal,'.'); 
		}
	};

}//FORMATTAZIONE VALORI DECIMALE PARSLEY

};

Intesa.FormsVub.getInstance = function() {
	
	if( !window.intesa ) {
		
		window.intesa = new Object();
		
	}
	if( !window.intesa.formsVub ) {
		
		window.intesa.formsVub = new Intesa.FormsVub();
		
	}
	
	return window.intesa.formsVub;

};

function check() {
	var radio = document.querySelectorAll("#radio");

	if(radio[0].checked || radio[1].checked){
	console.log("DONE")
	document.getElementById("repaymentDate").required = true;
	} else {
	document.getElementById("repaymentDate").required = false;
	}
}